import {
  ApplicationConfig,
  provideZonelessChangeDetection,
  provideBrowserGlobalErrorListeners,
  APP_INITIALIZER,
} from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withInterceptors, withFetch } from '@angular/common/http';
import { provideTranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { MessageService, ConfirmationService } from 'primeng/api';

import { appRoutes } from './app.routes';
import {
  authInterceptor,
  tenantInterceptor,
  errorInterceptor,
} from '@joyinvoice/web/shared/data-access';
import { ENVIRONMENT } from '@joyinvoice/web/shared/util';
import { environment } from '../environments/environment';
import { AuthService } from '@joyinvoice/web/shared/data-access';

export function initializeAuthFactory(auth: AuthService) {
  return () => auth.initializeAuth();
}

export const appConfig: ApplicationConfig = {
  providers: [
    // Zoneless Change Detection
    provideZonelessChangeDetection(),

    // Client Hydration
    provideClientHydration(),

    // Browser error listeners
    provideBrowserGlobalErrorListeners(),

    // Provide environment config via injection token
    { provide: ENVIRONMENT, useValue: environment },

    // Init Auth
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuthFactory,
      deps: [AuthService],
      multi: true,
    },

    // Router with component input binding for route params
    provideRouter(appRoutes, withComponentInputBinding()),

    // HTTP with interceptor chain
    provideHttpClient(
      withFetch(),
      withInterceptors([tenantInterceptor, authInterceptor, errorInterceptor]),
    ),

    // Animations (for PrimeNG)
    provideAnimationsAsync(),

    // PrimeNG Configuration
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
        },
      },
    }),

    // Translate Service
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: TranslateHttpLoader,
    }),
    provideTranslateHttpLoader({
      prefix: '/i18n/',
      suffix: '.json',
    }),

    // PrimeNG Services
    MessageService,
    ConfirmationService,
  ],
};
